import { api } from '@/lib/api/client'
import type { ShopSettings } from '../model/types'

export const settingsApi = {
  get()   { return api.get<ShopSettings>('/settings') },
  update(patch: Partial<ShopSettings>) {
    return api.patch<ShopSettings>('/settings', patch)
  },
}
